<template>
    <div class="bo-dropdown-search">
        <div
            :class="['bo-dropdown-toggle', 'cursor-pointer', customClass]"
            data-toggle="dropdown"
            v-if="editable"
            :id="id"
        >
            <div
                class="option-item"
                :class="{
                    'option-placeholder': selectedItem == null || selectedItem == '',
                }"
                :title="selectedItem"
            >
                {{ selectedItem || optionPlaceholder }}
            </div>
            <div
                v-if="selectedItem"
                @click="unselect()"
                class="mr-4"
            >
                <i class="icon-cancelcircle-1"></i>
            </div>
        </div>
        <div
            class="input-group"
            v-else
        >
            <input
                type="text"
                :value="selectedItem"
                class="form-control"
                disabled
            />
        </div>

        <div class="dropdown-menu quick-search">
            <div class="searchbar">
                <div class="btn-search"><i class="icon-search"></i></div>
                <input
                    type="text"
                    v-model="searchQuery"
                    :placeholder="placeholder"
                    class="search-input dropdown"
                />
            </div>

            <div class="popup-trigger">
                <div
                    v-for="(item, index) in getItems"
                    :key="index"
                    class="dropdown-item"
                    @click="select(item)"
                    :title="item"
                >
                    <span>{{ item }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: "",
        },
        items: {
            type: Array,
            default: [],
        },
        editable: {
            type: Boolean,
            default: true,
        },
        value: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: window.bo?.generalTranslations?.search ?? "Search",
        },
        optionPlaceholder: {
            type: String,
            default: "",
        },
        customClass: {
            type: String,
            default: "",
        },
    },
    model: {
        prop: "value",
        event: "change",
    },
    data: function () {
        return {
            searchQuery: null,
        };
    },
    computed: {
        selectedItem: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
        getItems() {
            if (this.searchQuery) {
                const result = this.items.filter((item) => {
                    return item.toLowerCase().includes(this.searchQuery.toLowerCase());
                });

                return result;
            } else {
                return this.items;
            }
        },
    },
    methods: {
        select(item) {
            this.selectedItem = item;
        },
        unselect() {
            event.stopPropagation();
            this.selectedItem = null;
        },
        resetSearch() {
            this.searchQuery = null;
        },
    },
};
</script>
